import React from 'react'

import { BaseView, BaseText } from '@/components/base'
import { AppIcons } from '@/components/AppIcons'
import { useTheme } from '@/hooks/useTheme'

interface FilterTagProps {
  label: string
  onDelete?: () => void
}

export const FilterTag: React.FC<FilterTagProps> = ({ label, onDelete }) => {
  const theme = useTheme()

  return (
    <BaseView
      row
      align="center"
      px={12}
      py={8}
      gap={8}
      style={{
        backgroundColor: theme.colors.background.secondaryGray + '40',
        borderRadius: '16px',
        alignSelf: 'flex-start',
      }}
    >
      <BaseText fontSize={14} fontFamily="semibold" color="label.default">
        {label}
      </BaseText>

      {onDelete && (
        <BaseView
          center
          circle
          circleSize={16}
          style={{
            backgroundColor: theme.colors.background.secondaryGray,
            cursor: 'pointer',
          }}
          onClick={onDelete}
        >
          <AppIcons name="close" size={10} color="label.default" />
        </BaseView>
      )}
    </BaseView>
  )
}
